import { useState } from 'react';
import { BRAND } from '../data/products';
import GoldRule from '../components/GoldRule';
import { Reveal, RevealLines, Stagger, StaggerItem } from '../components/motion/Reveal';

export default function Contact() {
  const [form, setForm] = useState({ email: '', phone: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const onSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <div data-testid="contact-page">
      <section className="max-w-[1100px] mx-auto px-6 md:px-12 pt-20 md:pt-28 pb-16">
        <Reveal y={12}>
          <div className="eyebrow text-mb-muted mb-8">Write to the atelier</div>
        </Reveal>
        <h1 className="font-display italic text-5xl md:text-6xl lg:text-7xl text-mb leading-[0.95]">
          <RevealLines lines={['Quietly,', 'then slowly.']} />
        </h1>
        <Reveal delay={0.34} className="mt-10">
          <GoldRule size="med" />
        </Reveal>
      </section>

      <section className="max-w-[1100px] mx-auto px-6 md:px-12 pb-24">
        <div className="grid md:grid-cols-2 gap-16">
          <div>
            <Stagger className="space-y-8" gap={0.09}>
              <StaggerItem y={18}>
                <div className="eyebrow-sm text-mb-muted">Email</div>
                <a
                  href={`mailto:${BRAND.email}`}
                  className="mt-2 block font-display text-[22px] text-mb hover:text-gold transition-colors"
                  data-testid="contact-email-link"
                >
                  {BRAND.email}
                </a>
              </StaggerItem>
              <StaggerItem y={18}>
                <div className="eyebrow-sm text-mb-muted">Telephone</div>
                <a
                  href={`tel:${BRAND.phone.replace(/\s/g, '')}`}
                  className="mt-2 block font-display text-[22px] text-mb hover:text-gold transition-colors"
                  data-testid="contact-phone-link"
                >
                  {BRAND.phone}
                </a>
              </StaggerItem>
              <StaggerItem y={18}>
                <div className="eyebrow-sm text-mb-muted">Atelier</div>
                <div className="mt-2 font-display text-[18px] text-mb">
                  {BRAND.address}
                </div>
              </StaggerItem>
              <StaggerItem y={18}>
                <div className="hairline-t border-subtle pt-8">
                  <p className="font-display italic text-[16px] text-mb-muted leading-relaxed">
                    We return every message in the order it arrived. There is
                    no queue, only calendar.
                  </p>
                </div>
              </StaggerItem>
            </Stagger>
          </div>

          <Reveal delay={0.1}>
            {!submitted ? (
              <form onSubmit={onSubmit} data-testid="contact-form">
                <div>
                  <label className="mb-label">Email</label>
                  <input
                    data-testid="contact-field-email"
                    type="email"
                    className="mb-input"
                    value={form.email}
                    onChange={update('email')}
                    required
                  />
                </div>
                <div className="mt-8">
                  <label className="mb-label">Phone</label>
                  <input
                    data-testid="contact-field-phone"
                    type="tel"
                    className="mb-input"
                    value={form.phone}
                    onChange={update('phone')}
                    placeholder="Optional"
                  />
                </div>
                <div className="mt-8">
                  <label className="mb-label">Message</label>
                  <textarea
                    data-testid="contact-field-message"
                    className="mb-input"
                    rows={6}
                    value={form.message}
                    onChange={update('message')}
                    required
                  />
                </div>
                <div className="mt-10">
                  <button
                    type="submit"
                    className="btn-gold"
                    data-magnetic
                    data-testid="contact-submit-btn"
                  >
                    Send
                  </button>
                </div>
              </form>
            ) : (
              <div
                className="bg-mb-surface hairline border-subtle p-8 md:p-12"
                data-testid="contact-confirmation"
              >
                <div className="eyebrow text-gold mb-5">Received.</div>
                <h3 className="font-display italic text-3xl text-mb">
                  Your message is with us.
                </h3>
                <div className="mt-6">
                  <GoldRule />
                </div>
                <p className="mt-8 text-[14px] text-mb-muted">
                  We reply by email within one business day.
                </p>
              </div>
            )}
          </Reveal>
        </div>
      </section>
    </div>
  );
}
